//Done

import React, {useState, useEffect} from 'react';
import { Table, Button, Popconfirm, Modal, Form, Input, Row, Col} from 'antd';
  
export default function GradeTable () {
    const [modalVisible, setModalVisible] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [dataIsLoading, setDataIsLoading] = useState(false);

    const columns = [
        {
          title: 'Grades',
          dataIndex: 'grade',
          width: '80%',
          defaultSortOrder: 'ascend',
          sorter: (a, b) => a.grade - b.grade,
        },
        {
          title: 'Operation',
          dataIndex: 'operation',
          render: (text, record) => (            
                <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record)}>
                    <Button danger type="text">Delete</Button>
                </Popconfirm>
            )
        },
    ]; 

    const GradeModal = ({ visible, onCreate, onCancel }) => {
        const [form] = Form.useForm();
        return (
            <Modal
                visible={modalVisible}
                title="Creating a new grade"
                okText="Create"
                cancelText="Cancel"
                onCancel={onCancel}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreate(values);
                        })
                        .catch((info) => {console.log('Validate Failed:', info);});
                }}
                destroyOnClose={true}
            >
                <Form
                    form={form}
                    layout="vertical"
                    preserve={false}
                >
                    <Form.Item
                        label="Grade"
                        name="grade"
                        rules={[
                            {
                                required: true,
                                validator: checkGrade,
                            },
                        ]}  
                    >
                        <Input placeholder="JK/SK/1-12"/>
                    </Form.Item>                
                </Form>
            </Modal>
        );
    };
  
    const checkGrade = (rule, value) => {
        if (value === "JK" || value === "SK") {
            return Promise.resolve();
        } else {
            const numberValue = Number(value);
            if (numberValue >= 1 && numberValue <= 12) {
                return Promise.resolve();
            }
            return Promise.reject('Please input the Grade(Using JK or SK or a number between 1 to 12)');
        }
    }

    useEffect(() => {
        fetch('https://kh-studentrecordsystem.herokuapp.com/gradesInfo')
            .then(response => response.json())
            .then(data => {setDataSource(data.Data)})
            .catch(err => console.log(err))
    },[]);

    const onCreate = (values) => {
        const newData = {
            grade: values.grade
        }
        const index = dataSource.findIndex(x => x.grade === values.grade);
        if (index !== -1) {
            alert ('This grade has been created');
            setModalVisible(false)
        } else {
            setDataIsLoading(true);
            fetch('https://kh-studentrecordsystem.herokuapp.com/gradesInfo', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(newData),
            })
                .then(data => {
                    fetch('https://kh-studentrecordsystem.herokuapp.com/gradesInfo')
                        .then(response => response.json())
                        .then(data => {
                            setDataSource(data.Data);
                            setModalVisible(false);
                            setDataIsLoading(false);
                        })
                        .catch((error) => {console.error('Error:', error);});
                })
                .catch((error) => {console.error('Error:', error);});
        }
    };

//系统开发的原则，数据管理得越简单越好.前端只需把ID传给后端，由后端去操作，得到结果后再传前端去Re-Get。
//对于前段来说，是delete就应该用DELETE Method，不然会confused。然后让后端操作是Hard/Soft Delete。
    const handleDelete = (record) => {
        setDataIsLoading(true)
        fetch('https://kh-studentrecordsystem.herokuapp.com/gradesInfo', {
            method: 'DELETE',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(record),
        })
            .then(data => {
                fetch('https://kh-studentrecordsystem.herokuapp.com/gradesInfo')
                    .then(response => response.json())
                    .then(data => {
                        setDataSource(data.Data);
                        setDataIsLoading(false);
                    })
                    .catch(err => {console.log(err)})
            })
            .catch(err => {
                err.text()
                  .then(errorMessage => {
                    alert(errorMessage);
                  })
              })
    };
  
    return (
        <Row justify="center" >
            <Col xs={23} lg={{span: 22, offset: 1}} xl={{span: 22, offset: 3}}>
                <div>
                    <Button onClick={() => {setModalVisible(true)}} type="primary" className="pageMainFuncBtn">Add New Grade</Button>

                    <Table
                        rowKey={record => record._id}
                        bordered
                        dataSource={dataSource}
                        columns={columns}
                        pagination={{defaultPageSize: 20}}
                        loading={dataIsLoading}
                    />

                    <GradeModal
                        visible={modalVisible}
                        onCreate={onCreate}
                        onCancel={() => {setModalVisible(false);}}
                    />
                </div>
            </Col>
        </Row>
        
    );
};